// DS7.4.1
// for sales there is a specialized version - da-shared-react/SaleBanner
// for tier promos there is - da-shared-react/StripTierPromotion
import React from 'react';
import c from 'classnames';
import { ThemeOptions, ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import GhostButton from '../Buttons/GhostButton';
import PlainButtonOrLink from '../Buttons/PlainButtonOrLink';
import s from './PromoBanner.scss';
var PromoBanner = function (_a) {
    var className = _a.className, size = _a.size, variant = _a.variant, messageBeforeIcon = _a.messageBeforeIcon, icon = _a.icon, messageAfterIcon = _a.messageAfterIcon, ctaLabel = _a.ctaLabel, ctaHref = _a.ctaHref, ctaOnClick = _a.ctaOnClick, ctaBiData = _a.ctaBiData;
    var renderCtaButton = function () {
        return size === 'small' ? (React.createElement(PlainButtonOrLink, { className: c(s['text-link']), href: ctaHref, onClick: ctaOnClick, biData: ctaBiData }, ctaLabel)) : (React.createElement(GhostButton, { size: "small", variant: "main", className: s['button'], href: ctaHref, onClick: ctaOnClick, biData: ctaBiData }, ctaLabel));
    };
    var renderLayout = function () { return (React.createElement("div", { className: s['layout'] },
        messageBeforeIcon && (React.createElement("div", { className: s['message-before-icon'] }, messageBeforeIcon)),
        React.createElement("div", { className: s['icon'] }, icon),
        React.createElement("div", { className: s['message-after-icon-and-button'] },
            React.createElement("div", { className: s['message-after-icon'] }, messageAfterIcon),
            renderCtaButton()))); };
    var rootClassnames = c(s['root'], s["size-" + size], s["variant-" + variant], className);
    return variant === 'core' ? (React.createElement(ThemeOverride, { className: rootClassnames, theme: ThemeOptions.LIGHT }, renderLayout())) : (React.createElement("div", { className: rootClassnames }, renderLayout()));
};
PromoBanner.displayName = 'PromoBanner';
export default PromoBanner;
//# sourceMappingURL=PromoBanner.js.map